<!-- eslint-disable vue/no-v-html -->
<template>
  <div>
    <ProgressBar active-step="Thank you for visiting us" />
    <PageHeading :default-heading="pageHeader" />
    <div class="pvd-container container-divider">
      <p>{{ pd_content.minor_error_page.minor_error_message }}</p>
      <p>
        <a
          :href="pd_content.minor_error_page.go_to_fidelity_link"
          @click="handleLinkClick"
        >{{ pd_content.minor_error_page.go_to_fidelity_label }}</a>
      </p>
    </div>
  </div>
</template>

<script>
import PageHeading from '../components/PageHeading.vue';
import ProgressBar from '../components/ProgressBar.vue';
import dataHelper from '../mixins/dataHelper';
import measurement from '../mixins/measurement';
import utility from '../mixins/utility';

export default {
  name: 'MinorLoginError',
  components: {
    PageHeading,
    ProgressBar,
  },
  mixins: [dataHelper, measurement, utility],
  data() {
    return {
      backButtonAttempt: false,
    };
  },
  computed: {
    pageHeader() {
      return this.pd_content.minor_error_page.page_header;
    },
  },
  mounted() {
    this.configureBackButtonFunctionality(() => this.showBackWarning(
      this.pd_content.back_button_disabled_warning,
    ));
    this.track('minor-login-error', 'pageview');
    document.title = this.setTitle(this.pageHeader);
  },
  methods: {
    handleLinkClick() {
      this.track('go_to_fidelity_link', 'interaction');
    },
  },
};
</script>

<style scoped>
</style>
